<template>
  <div class="map" :id="id">
    <!-- <img :src="world" alt="" /> -->
    <!-- <DomeEchartWrap ref="world-map-2" id="world-map"></DomeEchartWrap> -->
  </div>
</template>

<script>
import World from '@/assets/map/json/world-reserve.json'
import * as echarts from 'echarts'
import _ from 'lodash'

export default {
  name: 'World',
  props: {
    id: {
      type: [Number, String],
      default: new Date().getTime()
    },
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      chart: null,
      options: {}
    }
  },
  computed: {

  },
  created () {
    this.$bus.$on('worldMap', this.checkTypeHandler)
    this.$once('hook:beforeDestory', () => {
      this.$bus.$off('worldMap')
    })
  },
  mounted () {
    let mapDiv = document.getElementById(`${this.id}`)
    let vThat = this
    this.chart = echarts.init(mapDiv)
    echarts.registerMap('world', { geoJSON: World })
    let newOptions = _.cloneDeep(this.config)
    let { inRangeColorA, inRangeColorB, options } = newOptions
    options.series[0].data = this.chartData
    _.set(options, 'visualMap.inRange.color', [inRangeColorA, inRangeColorB])
    let strFormatterFn = _.get(options, 'series[0].label.formatterFn')
    _.set(options, 'series[0].label.formatter', (item) => this.geoLabelFormatter(item, strFormatterFn))
    _.set(options, 'series[0].tooltip.formatter', (params) => this.geoTooltipFormatter(params))
    this.chart.setOption(options)
  },
  watch: {

  },
  methods: {
    checkTypeHandler (key) {
      console.log(key)
      this.chart.resize()
    },
    geoLabelFormatter (item, strFormatterFn) {
      let data = item
      return strFormatterFn.replace(/{([a-zA-Z]+)}|(\\n|\n)/g, ($1, $2, $3) => {
        if ($2) { return data[$2] }
        if ($3) { return '\r\n' }
        return ''
      })
    },
    geoTooltipFormatter (params) {
      if (params.value) {
        return params.name + ':' + params.value
      }
    }
  },
  components: {
  }
}
</script>

<style scoped lang="stylus">
.map
  width 100%
  height 100%

</style>
